// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"33":"f1db17ac","453":"4f50ac07","706":"147043c2"}[chunkId] + ".chunk.js";
};